import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqCircleOfCare');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'circle_of_care',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqCircleOfCare.js